import { requestStatuses } from 'modules/shared/constants';

const isSuccess = (requestStatus) => requestStatus === requestStatuses.success;

export default isSuccess;
